var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 24,
    viewBox: "0 0 394 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.373 0L131.067 8.2918H139.786L132.732 13.4164L135.427 21.7082L128.373 16.5836L121.32 21.7082L124.014 13.4164L116.961 8.2918H125.679L128.373 0Z",
    fill: "#ADC22A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.687 0L165.381 8.2918H174.099L167.046 13.4164L169.74 21.7082L162.687 16.5836L155.633 21.7082L158.327 13.4164L151.274 8.2918H159.992L162.687 0Z",
    fill: "#ADC22A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197 0L199.694 8.2918H208.413L201.359 13.4164L204.053 21.7082L197 16.5836L189.947 21.7082L192.641 13.4164L185.587 8.2918H194.306L197 0Z",
    fill: "#ADC22A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.313 0L234.008 8.2918H242.726L235.673 13.4164L238.367 21.7082L231.313 16.5836L224.26 21.7082L226.954 13.4164L219.901 8.2918H228.619L231.313 0Z",
    fill: "#ADC22A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.627 0L268.321 8.2918H277.04L269.986 13.4164L272.68 21.7082L265.627 16.5836L258.573 21.7082L261.268 13.4164L254.214 8.2918H262.933L265.627 0Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.eff8962ec6737f047b097fe6969cf3f5.svg";
export { ForwardRef as ReactComponent };